module.exports = __webpack_public_path__ + "static/media/universal.b16d289f.jpeg";